export function numberWithSpaces(x: number): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export function numberWithDot(x: number): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
